<template>
  <RadioGroup
    v-model="model"
    class="radio-filter-group flex items-center flex-wrap gap-y-2"
  >
    <RadioGroupLabel class="radio-filter-group__label mr-2">
      <span class="block truncate">{{ label }}</span>
    </RadioGroupLabel>
    <div class="flex items-center flex-wrap gap-y-2">
      <RadioGroupOption v-slot="{ checked }" :value="''">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >All</span
        >
      </RadioGroupOption>
      <RadioGroupOption
        v-for="(day, index) in days"
        :key="index"
        v-slot="{ checked }"
        :value="day"
      >
        <span
          class="radio-filter-group__option px-2 py-1 capitalize font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >{{ day }}</span
        >
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script lang="ts" setup>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';

const model = defineModel<'' | 'weekdays' | 'weekends'>();

export interface Props {
  size?: 'sm' | 'normal';
  label: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'normal',
});

const days = ['weekdays', 'weekends'];
</script>
